import React from 'react';
import styles from './index.module.scss';

const SIZE = 28;
const STROKE_WIDTH = 4;
const RADIUS = SIZE / 2;
const NORMALISED_RADIUS = RADIUS - STROKE_WIDTH / 2;
const CIRCUMFERENCE = 2 * Math.PI * NORMALISED_RADIUS;

/**
 * @param {object} props
 * @param {number} props.value - value between 0 and 1
 */
export default function Ring({ value = 0 }) {
  const strokeDashoffset = (1 - value) * CIRCUMFERENCE;

  return (
    <svg
      width={SIZE}
      height={SIZE}
      className={styles.ring}
      style={{ transform: 'rotate(-90deg)' }}
    >
      <circle
        cx={RADIUS}
        cy={RADIUS}
        r={NORMALISED_RADIUS}
        className={styles.ringTrack}
      />
      <circle
        cx={RADIUS}
        cy={RADIUS}
        r={NORMALISED_RADIUS}
        strokeWidth={STROKE_WIDTH}
        strokeDasharray={`${CIRCUMFERENCE} ${CIRCUMFERENCE}`}
        strokeDashoffset={strokeDashoffset}
        className={styles.ringProgress}
      />
    </svg>
  );
}
